<script setup>
import NavLink from "@/Components/NavLink.vue";

const props = defineProps({
    text: String,
    href: String
})
</script>
<template>
    <NavLink
        :href="href"
        class="flex cursor-pointer dark:bg-black justify-between shrink-0 w-25 h-25 sm:h-13 p-2 grow items-center flex-wrap gap-2 sm:flex-nowrap transition-colors hover:bg-slate-200 dark:hover:bg-slate-800 shadow-sm bg-white dark:bg-dark-blue rounded-lg">
        <slot name="icon"></slot>
        <div class="grow text-center dark:text-slate-200 text-sm">
            <span>{{ text }}</span>
        </div>
    </NavLink>
</template>

<style scoped>

</style>
